// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s48Qc","delete":"styles_delete__2sQjO","update":"styles_update__1B6Fi","add":"styles_add__1anaU"};